import { createFileRoute, redirect } from "@tanstack/react-router";

// Duplicate of /learn/saint-vs-traditional-tms — consolidated there.
// Edge 301 is mirrored in public/_redirects.
export const Route = createFileRoute("/saint-vs-traditional-tms")({
  beforeLoad: () => {
    throw redirect({ to: "/learn/saint-vs-traditional-tms", statusCode: 301 });
  },
});
